import React, { useState, useEffect } from "react";
import { MenuItem, FormControl, Select, InputLabel } from "@mui/material";

const SeriesDropdown = ({ seriesList, currentSeries, handleSeriesChange }) => {
  const [selectedSeries, setSelectedSeries] = useState({});
  console.log(seriesList);
  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setSelectedSeries(value);
    handleSeriesChange(value);
  };

  useEffect(() => {
    console.log("Current series:", currentSeries);
    console.log("Selected series:", selectedSeries);
    setSelectedSeries(currentSeries);
  }, [currentSeries]);

  return (
    <FormControl
      variant="standard"
      style={{ maxWidth: "375px", width: "100%" }}
    >
      <InputLabel id="series-label">
        {selectedSeries ? selectedSeries.title : "Select a Series"}
      </InputLabel>
      <Select
        labelId="series-label"
        id="series-select"
        value={selectedSeries?.title}
        onChange={handleChange}
        label="Select Series"
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: "200px",
              overflow: "auto",
              padding: "10px",
            },
          },
        }}
      >
        {seriesList.map((series, index) => (
          <MenuItem
            key={index}
            value={series}
            style={{ display: "block" }} // Enforce block display
          >
            {series.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SeriesDropdown;
